export const hideMaintenanceNotificationKey = 'HIDE_MAINTENANCE_NOTIFICATION';
